var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["streaks-button", { "streaks-button-mobile": _vm.isMobile }],
      attrs: { "data-testid": "streaks_button" }
    },
    [
      _c(
        "span",
        {
          staticClass: "current-streak",
          attrs: { "data-testid": "streaks_button_current_streak" }
        },
        [_vm._v("\n    " + _vm._s(_vm.currentStreak) + "\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "status" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "11",
              height: "17",
              viewBox: "0 0 11 17",
              fill: "none"
            }
          },
          [
            _c("path", {
              attrs: {
                "data-testid": "streaks_button_lightning_path",
                opacity: "0.75",
                d:
                  "M9.71625 5.11156H6.28363L7.55607 1.08209C7.67443 0.582312 7.31933 0.11377 6.87546 0.11377H2.61428C2.25918 0.11377 1.93367 0.394895 1.90408 0.769729L0.95715 8.26641C0.897967 8.73496 1.22347 9.10979 1.66735 9.10979H5.15915L3.79794 15.2008C3.70916 15.6694 4.03467 16.1067 4.47854 16.1067C4.74487 16.1067 4.9816 15.9818 5.09997 15.7319L10.3081 6.23606C10.604 5.76752 10.2489 5.11156 9.71625 5.11156Z",
                fill: _vm.completedTodaysStreak ? "#F2B135" : "#D0D0D0"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("StreakPopup", {
        ref: "streakPopup",
        attrs: {
          "current-streak": _vm.currentStreak,
          "problems-solved-in-current-streak":
            _vm.problemsSolvedInCurrentStreak,
          "is-mobile": _vm.isMobile,
          visible: _vm.popupVisible,
          "calendar-days": _vm.calendarDays,
          "notification-type": _vm.notificationType,
          "problems-required-per-day": _vm.problemsRequiredPerDay,
          "completed-todays-streak": _vm.completedTodaysStreak,
          "max-num-streak-charges": _vm.maxNumStreakCharges,
          "num-available-streak-charges": _vm.numAvailableStreakCharges
        },
        on: {
          "should-close": function($event) {
            return _vm.$emit("should-close")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }